<mx-form-dialog [definition]="dialogDefinition">
  <!-- Hold Details -->
  <px-hold-detail [hold]="hold"/>
  <mx-select-form-field fieldName="pickupBranch" overrideLabel="Pickup Location" [formGroup]="editHoldForm"
                        [options]="pickupBranchSelector | select: []" [includeUndefinedOption]="false"/>

  @if (isPaused) {
    <!-- Hold is paused, show Resume button. -->
    <div class="flex flex-row justify-between items-center w-full">
      <div class="flex flex-col gap-0">
        <p class="text-headline-small">Hold Paused</p>
        <p class="text-body-large">Hold is currently paused until {{ pauseUntilDateControl.value | format:'DATE_ONLY' }}</p>
      </div>

      <mx-text-button label="Resume Hold" (click)="onClickResumeHold()"/>
    </div>
  } @else {
    <!-- Hold is not paused, allow setting of pause date. -->
    <div class="text-headline-small">Pause Hold
      <div class="text-body-large">If you are unable to pick the item up before a specific date, you may indicate that here.</div>
    </div>
    <mx-date-form-field fieldName="pauseUntil" overrideLabel="Pause Until" [formGroup]="editHoldForm"/>
  }

  <!-- Cancel Hold button -->
  <div class="flex flex-row justify-center">
    <mx-outlined-button startIcon="close" label="Cancel Hold" color="error" (click)="onClickCancelHold()"/>
  </div>
</mx-form-dialog>
